// extracted by mini-css-extract-plugin
export default {"svgContainer":"SvgContainer2_svgContainer__KLKKY","top":"SvgContainer2_top__NtsBi","bottom":"SvgContainer2_bottom__OND24"};